import { Navigate, Outlet } from 'react-router-dom'

import Navigation from '@/components/Navigation'
import Loader from '@/components/Loader'

import { getAccessToken } from '@/api'
import { useMeQuery } from '@/auth/queries/auth'

export const PrivateRoute = () => {
  const { error, isLoading } = useMeQuery()
  const token = getAccessToken()

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Loader />
      </div>
    )
  }

  if (!token || !!error) {
    return <Navigate to="/login" replace />
  }

  return (
    <div className="flex h-full flex-col">
      <div className="p-3">
        <Navigation />
      </div>
      <Outlet />
    </div>
  )
}
